import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormControl, FormGroup } from '@angular/forms';
import { Agente, AgenteSituacao } from '@tivic-team/manager-ts/dist/mob';
import { AutoCompleteConfig } from 'app/core/ui/components/autocomplete/config/autocomplete.config';
import { AgenteSearch } from 'app/services/mob/agente.search';
import { AgenteService } from 'app/services/mob/agente.service';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
import { EMPTY, Observable, from } from 'rxjs';
import { filter, map, mergeMap, tap } from 'rxjs/operators';

@Component({
  selector: 'autocomplete-agente-ait-taxi',
  templateUrl: './autocomplete-agente-ait-taxi.component.html',
  styleUrls: ['./autocomplete-agente-ait-taxi.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class AutocompleteAgenteAitTaxiComponent implements OnInit {

  formGroup: FormGroup;
  
  autoCompleteInfracaoConfig = new AutoCompleteConfig({
    service: this._agenteService,
    keyword: 'nmAgente',
    useLabel: 'nmAgente',
    useValue: 'cdAgente'
  });

  constructor(
    private _agenteService: AgenteService,
    private _controlContainer: ControlContainer
  ) { }

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
  }
}
